export default __webpack_public_path__ + "static/media/RE.dc3a7168.svg";